import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VaFaqsComponent } from './faqs.component';
import { MatIconModule } from '@angular/material/icon';
import { VaSanitizePipe } from '@vendasta/uikit';

@NgModule({
  imports: [CommonModule, MatIconModule, VaSanitizePipe],
  declarations: [VaFaqsComponent],
  exports: [VaFaqsComponent],
})
export class VaFaqsModule {}
